var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyDocumentCargoCaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 40,
    viewBox: "0 0 64 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_640_2613)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_640_2613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 39.7027C49.6731 39.7027 64 36.592 64 32.7547C64 28.9174 49.6731 25.8066 32 25.8066C14.3269 25.8066 0 28.9174 0 32.7547C0 36.592 14.3269 39.7027 32 39.7027Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 13.6653L44.854 2.24866C44.367 1.47048 43.656 1 42.907 1H21.093C20.344 1 19.633 1.47048 19.146 2.24767L9 13.6663V22.8367H55V13.6653Z",
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.613 16.8126C41.613 15.2195 42.607 13.9043 43.84 13.9033H55V31.9057C55 34.0129 53.68 35.74 52.05 35.74H11.95C10.32 35.74 9 34.0119 9 31.9057V13.9033H20.16C21.393 13.9033 22.387 15.2165 22.387 16.8096V16.8314C22.387 18.4245 23.392 19.7109 24.624 19.7109H39.376C40.608 19.7109 41.613 18.4126 41.613 16.8195V16.8126Z",
    fill: "#FAFAFA",
    stroke: "#D9D9D9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_640_2613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_640_2613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDocumentCargoCaseIcon);
export default __webpack_public_path__ + "static/media/emptyDocumentCargoCaseIcon.6ac32e50f7f3fd288f1798fa3dcdc3e8.svg";
export { ForwardRef as ReactComponent };